module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_11.12691a33.png";